import { FormGroup } from "@angular/forms";
import { FieldDefinition } from "../../../../sections/webtrader/webtrader/message/fieldDefinition";

import { FormlyView } from "../FormlyView";

export class Acknoledgment extends FormlyView {

    constructor(
        fieldDefinition: FieldDefinition
    ) {
        super(new FormGroup({}), 
            [...fieldDefinition.entityAckFields], {});
    }

}